module.exports = __webpack_public_path__ + "img/arrow-right.cf622b5d.svg";